import { TradePlanData } from './tradePlanData';

const OPTION_INSTRUMENTS = ['option', 'future_option'];

export function validateTradePlan(tradePlan: TradePlanData) {
  // TODO is this necessary?
  if (tradePlan.direction === 'NONE') {
    return {
      status: false,
      message: 'Please select a trade plan direction.',
    };
  }
  if (tradePlan.currentQuantityBasisValue <= 0) {
    return {
      status: false,
      message: 'Quantity basis value must be larger than 0.',
    };
  }
  if (OPTION_INSTRUMENTS.includes(tradePlan.instrument)) {
    const optionManagement = tradePlan.optionManagement;
    // TODO need to make sure the direction of the options suits the trade direction
    if (Object.keys(optionManagement.validOptions).length === 0) {
      return {
        status: false,
        message: 'There are no valid options matching your configuration.',
      };
    }
  }
  const setupValidation = tradePlan.setupDetails[tradePlan.setup].validate(tradePlan);
  if (!setupValidation[0]) {
    return {
      status: false,
      message: setupValidation[1],
    };
  }

  Object.keys(tradePlan.entryTactics).forEach((entry) => {
    const entryValidation = tradePlan.entryTactics[entry].validate(tradePlan);
    if (!entryValidation[0]) {
      return {
        status: false,
        message: entryValidation[1],
      };
    }
  });
  Object.keys(tradePlan.positionTactics).forEach((positionTactic) => {
    const positionValidation =
      tradePlan.positionTactics[positionTactic].validate(tradePlan);
    if (!positionValidation[0]) {
      return {
        status: false,
        message: positionValidation[1],
      };
    }
  });
  Object.keys(tradePlan.exitTactics).forEach((exit) => {
    const exitValidation = tradePlan.exitTactics[exit].validate(tradePlan);
    if (!exitValidation[0]) {
      return {
        status: false,
        message: exitValidation[1],
      };
    }
  });
  return { status: true, message: '' };
  
}
